import { alpha, styled } from "@mui/material";
import { RichTreeViewPro } from "@mui/x-tree-view-pro";

export const RateBuilderTree = styled(RichTreeViewPro)(({ theme }) => ({
  "--level-identation-offset": "70px",
  "--tree-lines-width": "2px",
  "--if-else-lines-color": alpha("#000000", 0.3),
  "--lines-color": alpha("#000000", 0.3),
  "--children-outline-color": alpha("#000000", 0.07),
  "--main-line-offset": "45px",
  "--under-item-line-offset": "20px",
  "--if-else-line-offset": "16px",
  "--short-indentation-offset": "40px",
  "--short-line-offset": "20px",

  [theme.breakpoints.down("md")]: {
    "--level-identation-offset": "50px",
    "--main-line-offset": "30px",
    "--if-else-line-offset": "12px",
  },

  width: "calc( 100% - var(--level-identation-offset, 0px))",
  display: "flex",
  flexDirection: "column",
  marginLeft: "var(--level-identation-offset, 0px)",
})) as typeof RichTreeViewPro;
